import type { ClientConfig } from '@workspace/public-utils'

const hanaConfig: ClientConfig = {
  brandName: '하나복권',
  brandNameEn: 'HANA',
  logoIconText: '8',
  logoIconColor: '#DB2777',
  defaultSiteName: '하나복권',
  seoTitleSuffix: '공식 로또 번호 생성 서비스',
  tagline: '대한민국 1등 온라인 복권 플랫폼',
  subTagline: '당신의 꿈을 현실로 만들어주는 신뢰할 수 있는 복권 서비스',
  copyrightFallback: '하나복권(Hana Lottery)',
  ctaJoinText: '지금 바로 하나복권에 가입하고 첫 복권을 구매해보세요',
  whyChooseUs: '왜 하나복권을 선택해야 할까요?',
  statsSubtitle: '하나복권과 함께한 놀라운 성과들',
  joinNowCta: '지금 바로 하나복권과 함께하세요!',
  smartSystemCta: '하나복권의 스마트 번호 생성 시스템으로 다음 회차에 도전하세요',
  registerWelcome: 'HANA 하나복권과 함께하세요',
}

export default hanaConfig
